
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
// 仅保留简称和拼音，value 拼接为 "简称 拼音" 用于搜索
const PROVINCE_DATA = [
  { code: '京', pinyin: 'jing' },
  { code: '津', pinyin: 'jin' },
  { code: '沪', pinyin: 'hu' },
  { code: '渝', pinyin: 'yu' },
  { code: '冀', pinyin: 'ji' },
  { code: '豫', pinyin: 'yu' },
  { code: '云', pinyin: 'yun' },
  { code: '辽', pinyin: 'liao' },
  { code: '黑', pinyin: 'hei' },
  { code: '湘', pinyin: 'xiang' },
  { code: '皖', pinyin: 'wan' },
  { code: '鲁', pinyin: 'lu' },
  { code: '新', pinyin: 'xin' },
  { code: '苏', pinyin: 'su' },
  { code: '浙', pinyin: 'zhe' },
  { code: '赣', pinyin: 'gan' },
  { code: '鄂', pinyin: 'e' },
  { code: '桂', pinyin: 'gui' },
  { code: '甘', pinyin: 'gan' },
  { code: '晋', pinyin: 'jin' },
  { code: '蒙', pinyin: 'meng' },
  { code: '陕', pinyin: 'shaan' },
  { code: '吉', pinyin: 'ji' },
  { code: '闽', pinyin: 'min' },
  { code: '贵', pinyin: 'gui' },
  { code: '粤', pinyin: 'yue' },
  { code: '青', pinyin: 'qing' },
  { code: '藏', pinyin: 'zang' },
  { code: '川', pinyin: 'chuan' },
  { code: '宁', pinyin: 'ning' },
  { code: '琼', pinyin: 'qiong' },
  { code: '使', pinyin: 'shi' },
  { code: '领', pinyin: 'ling' },
  { code: '学', pinyin: 'xue' },
  { code: '警', pinyin: 'jing' },
];

@Component
export default class AntdPlateInput extends Vue {
  province_data = PROVINCE_DATA;
  visible = false;

  provinceCode: any = '';
  plateSuffix: any = '';

  @lazyInject(OrderService)
  orderService!: OrderService;

  formData: any = {};

  // Ant Design Select 自定义搜索过滤：匹配简称、全称、拼音
  private filterProvinceOption(input: string, option: any): boolean {
    const keyword = input.toLowerCase();
    const optionData = PROVINCE_DATA.find(
      (item) => item.code === option.componentOptions.propsData.value,
    );
    if (!optionData) return false;
    return (
      optionData.code.includes(keyword) || optionData.pinyin.includes(keyword)
    );
  }

  // 选中省份后自动聚焦后缀输入框
  private handleProvinceChange(): void {
    this.$nextTick(() => {
      const suffixInput = this.$el.querySelector(
        '.ant-input',
      ) as HTMLInputElement;
      suffixInput?.focus();
    });
  }

  // 过滤后缀：只保留字母和数字，自动转大写
  private filterSuffix(): void {
    this.plateSuffix = this.plateSuffix
      .replace(/[^A-Z0-9学警挂]/gi, '')
      .toUpperCase();
  }

  // 获取完整车牌号
  public getFullPlate(): string {
    return this.provinceCode + this.plateSuffix;
  }

  handleCancel() {
    this.visible = false;
    this.provinceCode = '';
    this.plateSuffix = '';
  }

  async handleOk() {
    const { bossId, shopId, id } = this.formData;
    const data = {
      user_id: bossId,
      shop_id: shopId,
      amap_order_id: id,
      plate_no: this.getFullPlate(),
    };
    console.log('plate', data);
    const res = await this.orderService.COrderVerify(data);
    if (res) {
      this.$message.success(`${res}`);
      this.visible = false;
      this.$emit('refresh');
      this.provinceCode = '';
      this.plateSuffix = '';
    }
  }

  init(value: any) {
    this.visible = true;
    this.formData = value;
    console.log('init', this.province_data);
  }
}
